import React from 'react';
import GenericShipmentRequest from '../GenericShipmentRequest';

const YarnShipmentRequest = () => (
  <GenericShipmentRequest
    sectionName="Yarn Section"
    sectionKey="Yarn"
    backRoute="/sections/yarn"
  />
);

export default YarnShipmentRequest;
